import { ReactNode, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export interface SlotProps {
  id: string;
  children: ReactNode;
}

export type SlotContentProps = {
  children?: ReactNode;
};

export const Slot = ({ id, children }: SlotProps) => {
  const [target, setTarget] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const element = document.getElementById(id);
    if (!element) return;

    setTarget(element);

    return () => setTarget(null);
  }, [id]);

  if (!target || !children) return null;

  return createPortal(children, target);
};
